export const requestMapperErrors = {
  REQUEST_MAPPER_EXCEPTION: {
    status: 500,
    code: 'REQUEST_MAPPER_EXCEPTION',
    title: 'Error Processing Request',
    subtitle: 'REQUEST ERROR',
    description: 'The system encountered an issue while processing the request. Please contact support for further assistance.',
    roles: {
      admin: {
        title: 'Mapper Error',
        subtitle: 'REQUEST MAPPER ERROR',
        description: 'There was an issue processing the request using the Request Mapper for this API. Please review the mapper logic and ensure it is configured correctly.',
        about: {
          title: 'More on this error',
          description: 'This error occurs when the system encounters a problem with the Request Mapper during the request processing phase. The Request Mapper is responsible for transforming and standardizing the data before it is sent to the API. Please review the mapper’s setup to ensure it’s functioning as expected.',
          link: { text: 'Learn More', url: 'https://mindcloud.document360.io/docs/gravity-standard-request-format' }
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  AUTH_REQUEST_MAPPER_EXCEPTION: {
    status: 500,
    code: 'AUTH_REQUEST_MAPPER_EXCEPTION',
    title: 'Error Processing Authentication',
    subtitle: 'AUTHENTICATION ERROR',
    description: 'The system encountered an issue while processing the authentication request. Please contact support for further assistance.',
    roles: {
      admin: {
        title: 'Auth Mapper Error',
        subtitle: 'AUTHENTICATION MAPPER ERROR',
        description: 'There was an issue processing the authentication request using the Auth Mapper. Please review the mapper logic and ensure it is configured correctly.',
        about: {
          title: 'More on this error',
          description: 'This error occurs when the system encounters a problem with the Auth Mapper during the authentication process. The Auth Mapper is responsible for standardizing authentication requests before sending them to external services. Please ensure the mapper is set up properly.'
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  API_REQUEST_MAPPER_EXCEPTION: {
    status: 500,
    code: 'API_REQUEST_MAPPER_EXCEPTION',
    title: 'Error Processing Request',
    subtitle: 'REQUEST ERROR',
    description: 'The system encountered an issue while processing the request. Please contact support for further assistance.',
    roles: {
      admin: {
        title: 'API Mapper Error',
        subtitle: 'API MAPPER ERROR',
        description: 'There was an issue processing the API request using the API Mapper. Please review the mapper logic and ensure it is configured correctly.',
        about: {
          title: 'More on this error',
          description: 'This error occurs when the system encounters a problem with the API Mapper during the request processing phase. The API Mapper standardizes requests to external APIs for consistency. Please check the API Mapper setup.',
          link: { text: 'Learn More', url: 'https://docs.mindcloud.co/docs/request-mappers' }
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  ACTION_REQUEST_MAPPER_EXCEPTION: {
    status: 500,
    code: 'ACTION_REQUEST_MAPPER_EXCEPTION',
    title: 'Error Processing Request',
    subtitle: 'REQUEST ERROR',
    description: 'The system encountered an issue while processing the request. Please contact support for further assistance.',
    roles: {
      admin: {
        title: 'Action Mapper Error',
        subtitle: 'ACTION MAPPER ERROR',
        description: 'There was an issue processing the action using the Action Mapper. Please review the mapper logic and ensure it is configured correctly.',
        about: {
          title: 'More on this error',
          description: 'This error occurs when the system encounters a problem with the Action Mapper while trying to execute an action. The Action Mapper standardizes the execution of actions to ensure consistent behavior across apps. Please review the configuration.',
          link: { text: 'Learn More', url: 'https://docs.mindcloud.co/docs/action-request-mapping' }
        }
      }
    },
    component: 'DefaultErrorPage'
  }
};
